import { newId } from "../model/surfDeck.js";
import { arrangeSlideText } from "./autoArrange.js";
import { getSurfLayout, normalizeLayoutId } from "./templates.js";
export function layersFromLayout(layout, contents) {
    return layout.slots.map((slot, index) => {
        const isImage = slot.role === "image";
        const type = isImage ? "image" : "text";
        const content = contents[slot.role]?.trim() ?? (isImage ? "" : "");
        return {
            id: newId(),
            type,
            x: slot.rect.x,
            y: slot.rect.y,
            w: slot.rect.w,
            h: slot.rect.h,
            z: index + 1,
            rotation: 0,
            content,
            textRole: slot.textRole,
            style: { slotRole: slot.role },
        };
    });
}
export function applyLayoutToSlide(slide, layoutId, contents, opts) {
    const normalizedId = normalizeLayoutId(layoutId);
    const layout = getSurfLayout(normalizedId);
    if (!layout)
        throw new Error(`Layout sconosciuto: ${layoutId}`);
    let next = {
        ...slide,
        layout: normalizedId,
        layers: layersFromLayout(layout, contents),
    };
    const autoArrange = opts?.autoArrange !== false && Boolean(opts?.theme);
    if (autoArrange && opts?.theme) {
        next = arrangeSlideText(next, opts.theme);
    }
    return next;
}
export function slideToCustomLayoutSlots(slide) {
    return slide.layers
        .filter((l) => l.type === "text" || l.type === "image")
        .map((l) => ({
        role: String(l.style?.slotRole ?? l.textRole ?? l.id),
        rect: { x: l.x, y: l.y, w: l.w, h: l.h },
        textRole: l.textRole ?? "body",
    }));
}
